import type { RouteRecordRaw } from 'vue-router';
import ROUTE_NAMES from '@/vue/routes/routeNames';
import SECTION_NAMES from '@/vue/routes/sectionNames';
import { usePermissionsStore } from '@/vue/stores/permissions';
import ServerIcon from '@/images/server.svg?component';

const meta = {
    title: SECTION_NAMES.SERVERS_AND_SERVICES,
    icon: ServerIcon,
    permissions: (): string[] => [usePermissionsStore().allPermissions.adminServersSsoConfigs],
};

export const ssoRoutes = [
    {
        path: '',
        name: ROUTE_NAMES.ADMIN_SSO_CONFIG_LIST,
        component: ():Promise<unknown> => import('@/vue/views/admin/Servers/SSO/AdminSsoConfigTable.vue'),
        meta,
    },
    {
        path: 'uploaded/new',
        name: ROUTE_NAMES.ADMIN_SSO_UPLOADED_CONFIG_NEW,
        component: () => import('./views/UploadedSsoConfigView.vue'),
        meta,
    },
    {
        path: 'uploaded/edit/:id(\\d+)',
        name: ROUTE_NAMES.ADMIN_SSO_UPLOADED_CONFIG_VIEW,
        component: () => import('./views/UploadedSsoConfigView.vue'),
        props: (route) => ({ configId: Number(route.params.id) }),
        meta,
    },
    {
        path: 'url/new',
        name: ROUTE_NAMES.ADMIN_SSO_URL_CONFIG_NEW,
        component: () => import('./views/UrlSsoConfigView.vue'),
        meta,
    },
    {
        path: 'url/edit/:id(\\d+)',
        name: ROUTE_NAMES.ADMIN_SSO_URL_CONFIG_VIEW,
        component: () => import('./views/UrlSsoConfigView.vue'),
        props: (route) => ({ configId: Number(route.params.id) }),
        meta,
    },
] satisfies RouteRecordRaw[];
